import React, { memo } from "react";
import { Stack, Avatar, Typography } from "@mui/material";
import { makeStyles } from "tss-react/mui";
import { SystemColorsEnum } from "../../style/types.js";
import "../../style/hooks.js";
const useStyles = makeStyles()((theme) => ({
  userInfoContainer: {
    margin: theme.spacing(2),
    alignItems: "center"
  },
  userInfoTextContainer: {
    minWidth: 0
  },
  userInfoText: {
    overflowX: "hidden",
    textOverflow: "ellipsis"
  }
}));
function UserInfoInner({ agentId, username, email, avatarOnly }) {
  const { classes } = useStyles();
  const avatarLetter = username?.charAt(0);
  const circleColors = [
    SystemColorsEnum.LightBlue,
    SystemColorsEnum.Bronze,
    SystemColorsEnum.LightGreen,
    SystemColorsEnum.Orange,
    SystemColorsEnum.LightGrey,
    SystemColorsEnum.DarkGrey,
    SystemColorsEnum.Violet,
    SystemColorsEnum.Coffee,
    SystemColorsEnum.Beige,
    SystemColorsEnum.Mint,
    SystemColorsEnum.Burgundy,
    SystemColorsEnum.SkyBlue,
    SystemColorsEnum.Pink,
    SystemColorsEnum.Emerald,
    SystemColorsEnum.WarmYellow,
    SystemColorsEnum.DarkTeal,
    SystemColorsEnum.Red,
    SystemColorsEnum.NavyBlue,
    SystemColorsEnum.Green,
    SystemColorsEnum.DarkPink,
    SystemColorsEnum.DarkViolet
  ];
  const avatarColor = circleColors[avatarLetter?.charCodeAt(0) % circleColors.length];
  return /* @__PURE__ */ React.createElement(Stack, { direction: "row", spacing: 2, className: classes.userInfoContainer }, /* @__PURE__ */ React.createElement(Avatar, { sx: { bgcolor: avatarColor, width: 48, height: 48 } }, avatarLetter?.toUpperCase()), !avatarOnly && /* @__PURE__ */ React.createElement(Stack, { direction: "column", spacing: 1, className: classes.userInfoTextContainer }, agentId && /* @__PURE__ */ React.createElement(Typography, null, agentId), /* @__PURE__ */ React.createElement(Typography, { variant: "h6", className: classes.userInfoText }, username), /* @__PURE__ */ React.createElement(Typography, { variant: "subtitle1", className: classes.userInfoText }, email)));
}
const UserInfo = memo(UserInfoInner);
export {
  UserInfo
};
//# sourceMappingURL=UserInfo.js.map
